<template>
  <div class="action hidebox">
    <div
      class="back-top"
      v-show="gotop"
      @click="toTop"
    >
      <img
        src="../assets/images/top.png"
        alt=""
      >
      <span>顶部</span>
    </div>
    <div
      @click="toPath"
      class="questionnaire "
    >
      <i class="iconfont">&#xe629;</i>
      <span>问卷调查</span>
    </div>

  </div>

</template>

<script>
export default {
  name: 'Questionnaire',
  data() {
    return {
      gotop: false
    }
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll() {
      const scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      scrolltop > 100 ? (this.gotop = true) : (this.gotop = false)
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    toPath() {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      this.$router.push('/www/survey')
    }
  }
}
</script>

<style lang="less" scoped>
.action {
  position: fixed;
  right: 0;
  bottom: 20%;
  border: 1px solid #eee;
  z-index: 100;
}
.questionnaire {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  width: 70px;
  height: 50px;

  color: #666;
  cursor: pointer;
  z-index: 100;
}
.back-top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  font-size: 12px;
  background: #fff;
  padding-top: 5px;
  color: #666;
  border-bottom: 1px solid #eee;
  img {
    width: 20px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
